<template>
  <div>
    <spinner-round :isLoading="loading"></spinner-round>
    <div v-if="program && !loading">
      <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
        <div slot="left">
          <h1 class="title is-4">
            <span class="has-text-weight-normal is-uppercase">{{program.name}}</span>
            <router-link
              :to="{name:'PromoteurVue', params: {id: program.promoteur.pk}}"
              v-if="(isAdmin || isEditor) && isDistributeurMode"
              class="has-text-weight-light has-text-grey is-uppercase"> - {{program.promoteur_name}}
            </router-link>
            <span v-else-if="!isExternal && isDistributeurMode"> - {{program.promoteur_name}}</span>
            <!-- <span v-if="program.progress_step" class="tag is-small is-primary">{{program.progress_step | programStepProgressLabel}}</span> -->
          </h1>
        </div>
        <!--<div slot="left-action">
          <div class="column is-paddingless is-border-left" slot="right-content" v-if="isAdmin">
            <a v-scroll-to="'#panelComp'" @click="changePanel(PANELS.ACCESS)"
               class="page-header-btn is-small">
              <span class="icon"><i class="fas fa-key is-size-5"></i></span>
              <span class="">Mandats</span>
            </a>
          </div>
        </div>-->
        <router-link slot="dropdown-content" :to="{name: 'ProgramEdit', params: {id: program.pk}}" class="dropdown-item"
                     v-if="isAdmin || isEditor">
          <span class="icon"><i class="fas fa-edit"></i></span><span>Modifier fiche programme </span>
        </router-link>
        <router-link :to="{name: 'ProgramChild', query: {program: program.pk}}"
                      class="dropdown-item" slot="dropdown-content" v-if="(isAdmin || isEditor) && !program.from_flux">
          <span class="icon"><i class="fas fa-plus-circle is-size-5"></i></span>
          <span class="">Ajouter lot et parking</span>
        </router-link>
        <!-- <router-link :to="{name: 'LotCreate', query: {program: program.pk}}"
                     class="dropdown-item" slot="dropdown-content" v-if="(isAdmin || isEditor) && !program.from_flux">
          <span class="icon"><i class="fas fa-plus-circle is-size-5"></i></span>
          <span class="">Ajouter un lot</span>
        </router-link> -->
        <!-- <router-link :to="{name: 'ParkingCreate', query: {program: program.pk}}"
                     class="dropdown-item" slot="dropdown-content" v-if="(isAdmin || isEditor) && !program.from_flux">
          <span class="icon"><i class="fas fa-plus-circle is-size-5"></i></span>
          <span class="">Ajouter un parking</span>
        </router-link> -->
        <!-- <a slot="dropdown-content" @click="importLotModal = true" class="dropdown-item" v-if="(isAdmin || isEditor) && !program.from_flux">
          <span class="icon"><i class="fas fa-cogs"></i></span>
          <span>Importer fichier lots</span>
        </a> -->
        <!-- <router-link slot="dropdown-content" :to="{name: 'ProgramDocumentEdit', params: {id: program.pk}}"
                     class="dropdown-item"
                     v-if="isAdmin || isEditor">
          <span class="icon"><i class="fas fa-folders"></i></span><span>Gestions documents</span>
        </router-link> -->
        <router-link slot="dropdown-content" :to="{name: 'ProgramDiffusionEdit', params: {id: program.pk}}"
                     class="dropdown-item"
                     v-if="(isAdmin || isEditor) && multidiffEnabled">
          <span class="icon"><i class="fas fa-rss"></i></span>
          <span>Diffusion annonce</span>
        </router-link>
        <a slot="dropdown-content" target="_blank" class="dropdown-item" :href="publicUrl" v-if="publicUrl && isMarExternalRestriction">
          <span class="icon"><i class="fas fa-browser"></i></span>
          <span>Site public</span>
        </a>
        <a v-if="this.currentUserCountry === 'MAR'" @click="getProgramPdf" class="dropdown-item" slot="dropdown-content">
          <span class="icon"><i class="fas fa-file-export"></i></span><span>Exporter fiche programme</span>
        </a>
        <a v-if="isAdmin" @click="xlsExportUrl" class="dropdown-item" slot="dropdown-content">
          <span class="icon"><i class="fas fa-file-export"></i></span><span>Exporter données programme</span>
        </a>
        <a v-if="isMarExternalRestriction" @click="xlsExportLotsUrl" class="dropdown-item" slot="dropdown-content">
          <span class="icon"><i class="fas fa-file-export"></i></span><span>Exporter données des lots</span>
        </a>
        <a @click.prevent.stop="beforeRemove" class="dropdown-item has-text-danger" v-if="canBeDeleted"
           slot="dropdown-content">
          <span class="icon"><i class="fas fa-trash-alt"></i></span><span>Supprimer programme</span>
        </a>
      </sticky>
      <div
        class="columns is-padding-left-on-btn-actions is-padding-right-on-btn-actions is-paddingless-bottom has-stickyColumn has-stickyColumn--left"
        id="columns-collapse">
        <div class="column is-4 is-3-fullhd is-paddingless-left is-paddingless-right">
          <div class="card has-bg-white is-bordered">
            <div v-if="isAdmin || isEditor" class="columns is-vcentered has-status-bar--left"
                 :class="statusClass">
              <div class="column is-padding-top-small is-padding-bottom-small">
                <span class="has-text-primary is-inline-block is-vcentered has-text-weight-bold">État :</span>
                <div class="control is-inline-block is-vcentered">
                  <div v-if="canChangeStatus" class="select is-small is-transparent is-pulled-left">
                    <select v-model="program.status" @change="updateStatus">
                      <option v-for="s in workflowStatusList" :value="s.value" :key="s.label">{{s.label}}</option>
                    </select>
                  </div>
                  <div v-else class="is-size-6">
                    {{program.status | workflowLabel}}
                  </div>
                </div>
                <div class="control is-padding-left is-inline-block is-vcentered is-border-left is-size-6"
                     v-if="(isAdmin || isEditor) && diffusion && diffusion.supports">
                  <router-link :to="{name: 'ProgramDiffusionEdit', params: {id: program.pk}}" v-if="multidiffEnabled">
                     <span @mouseover="diffusionTooltip = true" @mouseleave="diffusionTooltip = false" class="underlign-hover">
                      Publié dans <b>{{diffusion.supports.length}} supports de multidiffusions</b>.
                    </span>
                  </router-link>
                  <span class="c_tooltip tooltip-bottom is-dark" :class="{'active': diffusionTooltip}">
                    <div class="tooltip-inner">
                      <div class="column content">
                        <span v-for="support in diffusion.supports_name" :key="support"><b>{{support}}</b><br></span>
                      </div>
                    </div>
                  </span>
                </div>
                <div class="control is-margin-top-small is-size-6"
                     v-if="isAdmin && !['draft', 'archived'].includes(program.status)">
                  <i>
                    Visible par : {{internalUsersLength}} Vendeurs(s) /
                    <a @click="changePanel(PANELS.ACCESS)" v-scroll-to="'#panelComp'">{{accessExternalSellersCount}}
                      Prescripteur(s)</a>
                  </i>
                </div>
              </div>
            </div>
            <div class="columns has-bg-annonce is-vcentered" v-if="!program.is_optionable">
              <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
                <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
              </div>
              <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
                <div class="has-text-white is-italic is-size-7 has-text-weight-bold">
                  <span>Non optionnable (contacter responsable programme)</span>
                </div>
              </div>
            </div>
            <div class="columns has-bg-allotement is-vcentered" v-if="allotment && isAdmin">
              <div
                class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-paddingless-right"></div>
              <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
                <a class="is-uppercase is-size-7 has-text-weight-bold has-text-white" @click="changePanelMandat(PANELS.ACCESS)" v-scroll-to="'#panelComp'">{{allotment}}
                  allotement(s)</a>
              </div>
            </div>
            <div class="columns is-multiline" :class="{'is-border-top is-border-dashed': (isAdmin || isEditor)}">
              <div class="column is-12 columns is-column is-padding-top-small is-padding-bottom-small is-space-between">
                <div class="has-text-primary is-size-4">
                  {{program.name}}
                  <span class="icon has-text-black tooltip is-tooltip-right is-padding-left-xsmall is-size-5"
                        data-tooltip="Flux promoteur" v-if="isDistributeurMode && program.from_flux && !isExternal">
                    <i class="fas fa-rss"></i>
                  </span>
                </div>
                <div v-if="displayTags" class="columns is-gapless is-margin-top-small">
                  <div class="column is-12">
                    <div class="tags">
                      <span v-if="program.progress_step" class="tag is-info">{{programStepProgressLabel(program.progress_step)}}</span>
                      <!-- <span v-for="(c, i) in program.certifications" class="tag is-brand" :class="'avatar-0' + i % 6"
                            :key="i">{{c | programCertificationLabel}}</span> -->
                      <span v-for="t in program.tags" class="tag is-annonce" :key="t">{{t}}</span>
                      <span v-if="program.is_exclusive" class="tag is-exclusif">Exclusivité</span>
                      <!-- <span v-if="!program.is_optionable" class="tag is-warning">Non optionnable</span> -->
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="column is-12 columns is-gapless is-multiline is-padding-top-small is-padding-bottom-small">
                <div class="column is-narrow is-margin-right-xsmall">
                  <img class="is-max-height-55" alt="" height="110" width="" src="https://www.petite-entreprise.net/images-donnees/fiches/articles/images/champ___8/thumb_1351156334@w_378.jpg">
                </div>
                <div class="column is-narrow is-margin-right-xsmall">
                  <img class="is-max-height-55" alt="" height="110" width="" src="https://www.certivea.fr/uploads/certifications/64619455-Logo_NF_HQE_BT.png">
                </div>
                <div class="column is-narrow is-margin-right-xsmall">
                  <img class="is-max-height-55" alt="" height="110" width="" src="https://www.constructeurs-maisons.org/ftp/Images/normes-labels-certifications/les-normes-labels-certifications.jpg">
                </div>
              </div> -->
              <div v-if="program.certifications && program.certifications.length > 0"
                   class="column is-12 columns is-column is-padding-top-small is-padding-bottom-small is-space-between is-border-top is-border-dashed">
                <div class="is-flex is-wrap-flex">
                  <span v-for="(c, i) in program.certifications" :key="i">
                    <img class="img-certification is-padding-right-xsmall" :src="c | programCertificationImage"
                         @load="loaded" :alt="c | programCertificationLabel">
                  </span>
                </div>
              </div>

              <div @click="showMap" v-if="address && Object.values(address).length"
                   class="column is-12 columns is-column is-padding-top-small is-padding-bottom-small is-space-between is-border-top is-border-dashed graph-over graph-over--decoration">
                <div class="has-text-grey is-size-6">Adresse</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{address.line1}}<br>{{address.zip_code}} {{address.city}}
                  <br>
                  <span v-if="address.country.trim().toLowerCase() !== 'france'"><i>{{address.country}}</i></span>
                </div>
                <div class="is-size-6">
                  <a class="is-underline"><i>Voir sur la carte</i></a>
                </div>
              </div>
              <div v-if="$configs && $configs.COUNTRY === 'FRA'"
                class="column is-6 is-border-top is-border-right is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between">
                <div class="has-text-grey is-size-6">Dispositif(s)</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-if="taxDispositifs">{{taxDispositifs}}
                </div>
                <span class="is-margin-top-xsmall has-text-primary is-size-4" v-else>Aucun</span>
              </div>
              <div v-if="$configs && $configs.COUNTRY === 'FRA'"
                class="column is-6 is-border-top columns is-column is-border-dashed is-padding-top-small is-padding-bottom-small is-space-between">
                <span class="has-text-grey is-size-6">Zone</span>
                <span class="is-margin-top-xsmall has-text-primary is-size-4 is-uppercase" v-if="program.tax_zone">{{program.tax_zone}}</span>
                <span class="is-margin-top-xsmall has-text-primary is-size-4" v-else>--</span>
              </div>
              <div
                class="column is-6 is-border-top is-border-right is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between">
                <span class="has-text-grey is-size-6">{{actabilityTerm}}</span>
                <span class="is-margin-top-xsmall has-text-primary is-size-4" v-if="program.date_actabilite">{{program.date_actabilite | prettyTrimestre}}</span>
                <span class="is-margin-top-xsmall has-text-primary is-size-4" v-else>--</span>
              </div>
              <div
                class="column is-6 is-border-top is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between">
                <span class="has-text-grey is-size-6">Livraison</span>
                <span class="is-margin-top-xsmall has-text-primary is-size-4" v-if="program.date_livraison">{{program.date_livraison | prettyTrimestre}}</span>
                <span class="is-margin-top-xsmall has-text-primary is-size-4" v-else>--</span>
              </div>
              <div @click="goToLotsList"
                   class="column is-6 is-border-top is-border-right is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between graph-over graph-over--decoration">
                <div class="has-text-grey is-size-6">Lot(s) disponible(s)</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{isExternal && allotment ? allotment : availableLots.length}}
                </div>
              </div>
              <div
                class="column is-6 is-border-top is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between"
                v-if="isExternal && currentAccess && displayRemuneration">
                <div class="has-text-grey is-size-6">Taux commercialisation</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-if="currentAccess.remuneration">
                  {{currentAccess.remuneration | prettyPrice}}%
                </div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-else>--</div>
              </div>
              <div
                class="column is-6 is-border-top is-border-dashed columns is-column is-padding-top-small is-padding-bottom-small is-space-between"
                v-else-if="!isExternal && displayRemuneration">
                <div class="has-text-grey is-size-6">Taux commercialisation</div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-if="program.remuneration">
                  {{program.remuneration | prettyPrice}}%
                </div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4" v-else>--</div>
              </div>
            </div>
          </div>
          <div v-if="isAdmin && events && events.length> 0">
            <event-tracker-list v-if="isAdmin" :show-list="showLastEvents" :events="lastEvents" :last-event="lastEvent"
                                @toggle="showLastEvents = !showLastEvents"
                                :show-all="!!fullHistory && !!fullHistory.length"
                                @showAll="getFullHistory">
            </event-tracker-list>
          </div>
        </div>
        <div class="column is-8 is-9-fullhd is-paddingless-right">

          <div class="" id="panelComp">
            <div
              class="tabs is-separatedUnderlined is-fullwidth is-marginless-bottom has-bg-white is-sticky-in-mainColumn is-zindex-8 is-border-top is-border-left is-border-right">
              <ul class="has-text-weight-medium">
                <li :class="{'is-active' : panel === 'DESCRIPTION'}">
                  <a @click="changePanel(PANELS.DESCRIPTION)" v-scroll-to="'#panelComp'">Descriptif</a>
                </li>
                <li :class="{'is-active' : panel === 'DOCUMENTS'}">
                  <a @click="changePanel(PANELS.DOCUMENTS)" v-scroll-to="'#panelComp'">Documents</a>
                </li>
                <li :class="{'is-active' : panel === 'ACCESS'}" v-if="isAdmin">
                  <a @click="changePanel(PANELS.ACCESS)" v-scroll-to="'#panelComp'">Mandats</a>
                </li>
                <li :class="{'is-active' : panel === 'OPTIONS'}" v-if="isAdmin">
                  <a @click="changePanel(PANELS.OPTIONS)" v-scroll-to="'#panelComp'">Options</a>
                </li>
                <li :class="{'is-active' : panel === 'ADVS'}" v-if="isAdmin">
                  <a @click="changePanel(PANELS.ADVS)" v-scroll-to="'#panelComp'">Ventes</a>
                </li>
              </ul>
            </div>
            <component :is="panelComponent"
                       :program="program"
                       :lots="lots"
                       :access="access"
                       :promoteur-accesses="promoteurAccess"
                       :options="options"
                       :advs="advs"
                       :setTab="tab"
                       :loading="loadingAccess"
                       @reloadAccess="getAccess"
                       @updateAccess="updateAccess"
                       @deleteAccess="deleteAccess"
            ></component>
          </div>
          <div class="has-bg-white is-border is-margin-top-large"
               id="mapVue" v-show="panel === 'DESCRIPTION' && program">
            <div>
              <program-map v-if="!googleMode" ref="map" :source="program"></program-map>
              <div v-else class="vue-map-container" style="width: 100%; height: 500px; background-color: white;">
                <div ref="map" style="width: 100%; height: 500px;"></div>
                <gmap-filter :source="program" :map="$refs.map"
                             v-if="program && $refs.map"></gmap-filter>
              </div>
            </div>
          </div>
          <div class="has-bg-light is-border is-padding-bottom-xsmall is-margin-top-large" id="lots"
               v-if="lots">
            <div class="is-padding has-bg-white is-border-bottom">
              <div class="title is-5 is-uppercase">Lot<span v-if="lots.length > 0">s</span> du programme</div>
            </div>
            <div class="tabs is-separatedUnderlined is-fullwidth is-marginless-bottom has-bg-white">
              <ul class="has-text-weight-medium">
                <li :class="{'is-active' : panelList === 'LOGEMENT'}" style="max-width: 50%">
                  <a @click="changeListPanel(PANELSLIST.LOGEMENT)">{{filteredLogement.length}} logement(s)</a>
                </li>
                <li :class="{'is-active' : panelList === 'PARKING'}" style="max-width: 50%">
                  <a @click="changeListPanel(PANELSLIST.PARKING)">{{filteredParking.length}} parking(s)</a>
                </li>
              </ul>
            </div>
            <stock-lots class="is-margin-bottom-large"
                        :from-card="true"
                        :source-lots="lotsList"
                        @sort="sort"
                        :params-list="paramsList"
                        :is-parking="panelList === 'PARKING'"
            ></stock-lots>
          </div>
        </div>
      </div>
    </div>
    <!-- <program-lots-import-modal v-if="importLotModal" :active="importLotModal" @close="importLotModal = false"
                               @reloadLots="getLots()"></program-lots-import-modal> -->
  </div>
</template>

<script>
  import { DefaultValues, DownloadFile, EventTrackerMx, Error } from '@/mixins'
  import { mapGetters, mapState } from 'vuex'
  import { bus, EVENTS } from '@/services/bus/index.js'
  import { exportXls } from '@/utils'
  import cloudinary from 'cloudinary-core'
  import GmapFilter from '@/components/utils/GmapFilter'
  import ProgramMap from './ProgramMap'
  import ProgramAccessList from './Tabs/ProgramAccessList'
  import ProgramDocumentsList from './Tabs/ProgramDocumentsList'
  import ProgramAdvList from './Tabs/ProgramAdvList.vue'
  import ProgramOptionList from './Tabs/ProgramOptionList'
  import ProgramDescription from './Tabs/ProgramDescription'
  import ProgramLotsImportModal from './ProgramLotsImportModal'
  import StockLots from '../stock/StockLots'
  import { isNil, compact, uniq, concat } from 'lodash'
  import { downloadURI } from '../../utils'
  import 'quill/dist/quill.snow.css'

  const removeMd = require('remove-markdown')
  const PANELS = Object.freeze({
    DESCRIPTION: 'DESCRIPTION',
    DOCUMENTS: 'DOCUMENTS',
    ACCESS: 'ACCESS',
    OPTIONS: 'OPTIONS',
    ADVS: 'ADVS'
  })
  const PANELSLIST = Object.freeze({
    LOGEMENT: 'LOGEMENT',
    PARKING: 'PARKING'
  })

  export default {
    name: 'ProgramVue',
    mixins: [DefaultValues, DownloadFile, EventTrackerMx, Error],
    components: {
      ProgramAccessList,
      ProgramDocumentsList,
      ProgramDescription,
      ProgramAdvList,
      ProgramOptionList,
      ProgramMap,
      StockLots,
      ProgramLotsImportModal,
      GmapFilter
    },
    data () {
      return {
        program: {},
        lotLoading: false,
        promoteurAccess: null,
        options: [],
        advs: [],
        programAccess: null,
        diffusion: null,
        diffusionLoading: false,
        loading: true,
        diffusionTooltip: false,
        cl: cloudinary.Cloudinary.new({ cloud_name: 'batiment-b' }),
        access: [],
        panel: PANELS.DESCRIPTION,
        PANELS: PANELS,
        panelList: PANELSLIST.LOGEMENT,
        PANELSLIST: PANELSLIST,
        lots: [],
        poiMarkers: [],
        loadingMap: false,
        loadingLots: false,
        loadingAccess: false,
        totalPage: 0,
        currentPage: 0,
        sortBy: {},
        service: this.$api.programService,
        allotment: 0,
        tab: null,
        imgLoad: false,
        importLotModal: false
      }
    },
    computed: {
      ...mapState(['currentUser', 'internalUsersLength', 'quickview', 'configs']),
      ...mapGetters(['isAdmin', 'isExternal', 'isSectorManager', 'isEditor', 'isPromoteurMode', 'isDistributeurMode', 'displayRemuneration', 'currentCompanyPk', 'currentUserCountry']),
      googleMode () {
        return this.$configs.COUNTRY !== 'FRA'
      },
      isMarExternalRestriction () {
        if (this.currentUserCountry === 'MAR') {
          return !this.isExternal
        } else {
          return true
        }
      },
      publicUrl () {
        if (this.$configs.VADIMM_PUBLIC && this.program) {
          const host = this.$configs.VADIMM_PUBLIC
          return `${host}/programs/${this.program.pk}`
        }
        return null
      },
      actabilityTerm () {
        if (!this.configs) return
        let term = {
          FRA: 'Actabilité',
          MAR: 'Titre foncier'
        }
        return term[this.configs.COUNTRY]
      },
      eventEntity () {
        return this.program
      },
      currentAccess () {
        if (isNil(this.programAccess) === false) {
          return this.programAccess
        }
        if (isNil(this.promoteurAccess) === false && this.isDistributeurMode) {
          return this.promoteurAccess
        }
        return null
      },
      paramsList () {
        return {
          loading: this.loadingLots,
          totalPage: this.totalPage,
          sortBy: this.sortBy,
          currentPage: this.currentPage
        }
      },
      multidiffEnabled () {
        let config = JSON.parse(this.$configs.MULTIDIFF_ENABLED)
        return config
      },
      mapOptions () {
        return {
          styles: this.mapStyle
        }
      },
      canBeDeleted () {
        return this.isAdmin
      },
      diffusionInfo () {
        if (this.diffusion) {
          return this.diffusion.supports_name.join(', ')
        }
        return null
      },
      canChangeStatus () {
        return this.isAdmin
      },
      address () {
        return this.program.address
      },
      programPk () {
        return this.$route.params.id
      },
      setMarker () {
        return { lat: this.program.location.latitude, lng: this.program.location.longitude }
      },
      taxDispositifs () {
        return this.program.tax_dispositifs.map(x => (this.taxDispositifsData[x]) ? this.taxDispositifsData[x].label : x).join(', ')
      },
      mainPicture () {
        if (this.program.pictures && this.program.pictures.length === 0) return 'http://res.cloudinary.com/batiment-b/image/upload/residence_i9fdly.png'
        else return this.program.pictures[0].path
      },
      statusClass () {
        const COLORS = {
          'available': 'has-status-bar--disponible',
          'draft': 'has-status-bar--draft',
          'archived': '',
          'private': 'has-status-bar--private'
        }
        return COLORS[this.program.status]
      },
      panelComponent () {
        const components = {
          [PANELS.DESCRIPTION]: 'ProgramDescription',
          [PANELS.DOCUMENTS]: 'ProgramDocumentsList',
          [PANELS.ACCESS]: 'ProgramAccessList',
          [PANELS.OPTIONS]: 'ProgramOptionList',
          [PANELS.ADVS]: 'ProgramAdvList'
        }
        return components[this.panel]
      },
      displayTags () {
        return (this.program.certifications && this.program.certifications.length) ||
          (this.program.tags && this.program.tags.length) ||
          this.program.progress_step ||
          this.program.is_exclusive ||
          !this.program.is_optionable
      },
      events () {
        if (this.program) {
          return this.program.events
        } else {
          return []
        }
      },
      accessExternalSellersCount () {
        if (this.program.status === 'private') {
          return this.access.length
        } else {
          let allProgramAccesses = concat(this.promoteurAccess, this.access)
          return uniq(compact(allProgramAccesses.map(x => {
            if (x && x.company) return x.company
          }))).length
        }
      },
      filteredLogement () {
        return this.lots.filter(x => x.nature !== 'parking')
      },
      filteredParking () {
        return this.lots.filter(x => x.nature === 'parking')
      },
      lotsList () {
        if (this.panelList === PANELSLIST.PARKING) {
          return this.filteredParking
        } else return this.filteredLogement
      },
      availableLots () {
        return this.lots.filter(x => ['available', 'optioned'].includes(x.status))
      }
    },
    watch: {
      '$route' (val, oldVal) {
        if (val && oldVal && val.params.id !== oldVal.params.id) {
          this.getProgram()
        }
      },
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'EDIT_ACCESS') {
            this.$api.accessService.patch(results.pk, results).then(r => {
              this.access.find(x => {
                if (x && x.pk === results.pk) {
                  Object.assign(x, r.data)
                  this.$notify({
                    type: 'is-success',
                    text: 'Le mandat à été mis à jour.'
                  })
                }
              })
            }).catch(err => {
              console.log(err)
              this.$notify({
                type: 'is-danger',
                text: 'Erreur lors de la mise à jour du mandat.'
              })
            })
          }
        }
      },
      lots (v) {
        window.setTimeout(() => {
          this.calcMinHeight()
        }, 200)
      }
    },
    methods: {
      async getProgramPdf () {
        let url = this.$configs.APIROOT + '/pdf/program-brochure/' + this.program.pk
        try {
          let dossierLink = await this.$api.axios.get(url)
          let link = document.createElement('a')
          link.href = dossierLink.data
          link.target = '_blank'
          link.click()
        } catch (err) {
          this.handleError(err, 'Impossible de générer l\'export de la fiche programme')
        }
      },
      loaded () {
        this.imgLoad = true
      },
      changePanel (panel) {
        this.tab = null
        this.panel = panel
      },
      changePanelMandat (panel) {
        this.tab = 'access'
        this.panel = panel
      },
      changeListPanel (panel) {
        this.panelList = panel
      },
      xlsExportLotsUrl () {
        const query = { program: this.program.pk }
        return exportXls('lots-export', query, false, `${this.program.name}-LOTS`)
      },
      xlsExportUrl () {
        const apiUrl = this.$configs.APIROOT
        const token = `token=${this.$api.token}`
        let exportURI = `${apiUrl}/export/fullprogram/` + this.program.pk + '?' + token
        return downloadURI(exportURI, 'Export.xlsx')
      },
      updateStatus () {
        const status = this.program.status
        let cb = () => {
          let IDS = {
            'archived': 'zLynaCi2aWaUMuGIcwaqg',
            'draft': '2SRdlfVm9O0Ae444SW40sM',
            'available': '4ncpu5K3ks66cO8wmo8EYC'
          }
          let entryId = IDS[status]
          if (entryId && this.$contentful) {
            this.$contentful.getEntry(entryId)
              .then(entry => {
                // let converter = new showdown.Converter()
                let text = entry.fields.text
                let msg = removeMd(text)
                this.$notify({
                  type: 'is-success',
                  text: msg
                })
              })
          } else {
            this.$notify({
              type: 'is-success',
              text: 'Programme mis à jour.'
            })
          }
        }
        this.patchProgram({ status: status }, cb)
      },
      getProgram () {
        this.loading = true
        this.service.getOne(this.programPk).then(res => {
          this.loading = false
          this.program = res.data
          this.getLots()
          if (this.isExternal) this.getProgramAccess()
          if ((this.isAdmin || this.isExternal) && this.isDistributeurMode) this.getPromoteurAccess()
          if (this.program.diffusion_enabled && this.isAdmin) this.getDiffusion()
          if (this.isAdmin) {
            this.getProgramOptions()
            this.getProgramAdvs()
          }
        }).catch(err => {
          console.log(err)
          this.$router.replace({ name: 'NotFound' })
        })
      },
      getDiffusion () {
        this.diffusionLoading = true
        this.service.getOneDiffusion(this.programPk)
          .then(res => {
            this.diffusion = res.data
            this.diffusionLoading = false
          })
          .catch(err => {
            console.log(err)
            this.diffusionLoading = false
          })
      },
      getProgramOptions () {
        let query = {
          program: this.program.pk
          // status: ['approved', 'waiting_list']
        }
        this.$api.optionService.get(query).then(r => {
          this.options = r.data.items
        })
      },
      getProgramAdvs () {
        let query = {
          program: this.program.pk,
          status: ['reserved', 'sold']
        }
        this.$api.advService.get(query).then(r => {
          this.advs = r.data.items
        })
      },
      beforeRemove () {
        this.$swal({
          title: 'Suppression programme',
          text: 'Souhaitez-vous vraiment supprimer ce programme ?',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          cancelButtonColor: '#363636',
          showCloseButton: true
        }).then(res => {
          console.log(res)
          if (res.value) {
            this.deleteProgram()
          }
        })
      },
      deleteProgram () {
        this.loading = true
        this.service.delete(this.programPk)
          .then(res => {
            this.loading = false
            this.$router.push({ name: 'StockPrograms' })
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            this.$notify({
              type: 'is-danger',
              text: 'Impossible de supprimer ce programme.'
            })
          })
      },
      taxName (value) {
        if (!value) return ''
        value = value.toString().split('_').join(' ')
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      patchProgram (data, cb = null) {
        this.service.patch(this.programPk, data)
          .then(res => {
            this.program = res.data
            if (cb) {
              cb()
            } else {
              this.$notify({
                type: 'is-success',
                text: 'Programme modifié avec succès'
              })
            }
          })
      },
      cloudinaryImage (value) {
        return this.cl.url(value.cloudinary_id, {
          aspect_ratio: '16:9',
          crop: 'fill',
          quality: 'auto',
          fetchFormat: 'auto'
        })
      },
      getProgramAccess () {
        this.loadingAccess = true
        let query = {
          program: this.programPk,
          per_page: 1
        }
        if (this.isExternal) {
          query.company = this.currentCompanyPk
        }
        this.$api.accessService.get(query).then(r => {
          this.loadingAccess = false
          if (r.data.items.length > 0) {
            this.programAccess = r.data.items[0]
          }
        }).catch(() => {
          this.loadingAccess = false
        })
      },
      getPromoteurAccess (page = 1) {
        this.loadingAccess = true
        let query = {
          promoteur: this.program.promoteur.pk || this.program.promoteur,
          page,
          sort: 'company_name:asc'
        }
        if (this.isExternal) {
          query.company = this.currentCompanyPk
          query.per_page = 1
        }
        this.$api.accessService.getPromoteurAccess(query).then(r => {
          this.loadingAccess = false
          if (this.isExternal) {
            if (r.data.items.length > 0) this.promoteurAccess = r.data.items[0]
          } else {
            if (!Array.isArray(this.promoteurAccess)) this.promoteurAccess = []
            this.promoteurAccess = this.promoteurAccess.concat(r.data.items)
            if (r.data.page < r.data.pages) {
              page++
              this.getPromoteurAccess(page)
            } else {
              this.loadingAccess = false
            }
          }
        }).catch(() => {
          this.loadingAccess = false
        })
      },
      getAccess (page = 1) {
        if (page === 1) this.access = []
        this.loadingAccess = true
        let query = {
          program: this.programPk,
          page
        }
        if (this.isExternal) {
          query.company = this.currentCompanyPk
        }

        this.$api.accessService.get(query).then(r => {
          let accessPk = this.access.map(x => x.pk)
          let newAccess = r.data.items.filter(x => !accessPk.includes(x.pk))
          this.access = this.access.concat(newAccess)
          if (r.data.page < r.data.pages) {
            page++
            this.getAccess(page)
          } else {
            this.loadingAccess = false
            this.getAllotment()
          }
        })
      },
      getAllotment () {
        let param = {
          program: this.programPk
        }
        if (this.isExternal) {
          param.company = this.currentCompanyPk
        }
        this.$api.accessService.getAllotments(param).then(r => {
          this.allotment = r.data.total
        })
      },
      openNewMap () {
        if (this.program && this.program.location) {
          const address = `${this.program.location.latitude},${this.program.location.longitude}`
          window.open(`https://maps.google.com/maps?t=h&q=${address}&z=13`, '_blank')
        }
      },
      getCurrentLocation () {
        this.loadingMap = true
        if (localStorage.getItem('userAddress')) {
          this.openGoogleMaps(JSON.parse(localStorage.getItem('userAddress')), this.program.address)
        } else {
          if ('geolocation' in navigator) navigator.geolocation.getCurrentPosition(this.getGoogleMaps)
          else this.loadingMap = false
        }
      },
      getGoogleMaps (position) {
        const geocoder = new window.google.maps.Geocoder()
        const place = { lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude) }
        geocoder.geocode({ 'location': place }, (results, status) => {
          this.loadingMap = false
          if (status === 'OK') {
            this.openGoogleMaps(results[0].formatted_address, this.program.address)
            localStorage.setItem('userAddress', JSON.stringify(results[0].formatted_address))
          }
        })
        this.loadingMap = false
      },
      openGoogleMaps (results, address) {
        this.loadingMap = false
        const origin = results.split(' ').join('+')
        const destination = `${address.line1 || ''}+${address.zip_code}+${address.city}`
        window.open(`https://www.google.fr/maps/dir/${origin}/${destination}/`, '_blank')
      },
      updateAccess (data) {
        this.getAccess()
      },
      deleteAccess (id) {
        const d = {
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce mandat ?',
          confirmButtonText: 'Supprimer'
        }
        this.$swal(d).then(r => {
          if (r.value) {
            this.loadingAccess = true
            this.$api.accessService.delete(id).then(() => {
              this.loadingAccess = false
              this.$notify({
                type: 'is-success',
                text: 'Le mandat est en cours de suppression.'
              })
              let idx = this.access.findIndex(x => x.pk === id)
              this.access.splice(idx, 1)
            }).catch(() => {
              this.loadingAccess = false
              this.$notify({
                type: 'is-danger',
                text: 'Erreur lors de la suppression du mandat.'
              })
            })
          }
        })
      },
      lotLoadingHandler (isLoading) {
        this.lotLoading = isLoading
      },
      // async getProgramLots (filters = {}, page = 1) {
      //   let params = { program: this.programPk, page, per_page: 200, ...filters }
      //   try {
      //     let { data } = await this.$api.get(this.$resources.LOT, params)
      //     if (page > 1) {
      //       let totalLots = concat(data.items, this.lots)
      //       this.lots = totalLots
      //     } else {
      //       this.lots = data.items
      //     }
      //     if (data.page < data.pages) {
      //       page++
      //       this.getProgramLots({}, page)
      //     }
      //   } catch (e) {
      //     console.log(e)
      //   }
      // },
      getLots (query, page = 1) {
        this.loadingLots = true
        let params = {
          page,
          program: this.programPk,
          ...query
        }
        this.$api.lotService.get(params).then(r => {
          this.loadingLots = false
          // this.lots = r.data.items
          this.totalPage = r.data.pages
          this.currentPage = r.data.page
          if (this.filteredLogement.length === 0 && this.filteredParking.length > 0) {
            this.panelList = 'PARKING'
          }
          if (page > 1) {
            let totalLots = concat(r.data.items, this.lots)
            this.lots = totalLots
          } else {
            this.lots = r.data.items
          }
          if (r.data.page < r.data.pages) {
            page++
            this.getLots({}, page)
          }
        }).catch(() => {
          this.loadingLots = false
        })
      },
      sort ({ v, e, sortBy }) {
        let params = {
          sort: `${v}:${e.order}`
        }
        this.getLots(params)
        this.sortBy = sortBy
      },
      showMap () {
        this.panel = PANELS.DESCRIPTION
        setTimeout(() => {
          this.$scrollTo('#mapVue')
        }, 200)
      },
      goToLotsList () {
        this.$scrollTo('#lots')
        if (this.filteredLogement.length === 0 && this.filteredParking.length > 0) {
          this.panelList = 'PARKING'
        }
      },
      calcMinHeight () {
        // Calcul de la hauteur minimum pour que ds un fichier lot quand on passe de l'onglet "Lot" à "Parking" la hauteur de la page ne se réduise pas
        // Idem ds lotVue.vue
        let wraperEl = this.$el.querySelector('#lots')
        if (wraperEl === null || undefined) return true
        let wrapHeight = wraperEl.offsetHeight
        wraperEl.style.minHeight = wrapHeight + 'px'
      }
    },
    created () {
      this.getProgram()
      this.getAccess()
    },
    mounted () {
      bus.$on(EVENTS.RELOAD, ({mode}) => {
        if (mode === 'ACCESS') {
          this.getAccess()
        }
      })
      this.calcMinHeight()
    },
    destroyed () {
      bus.$off(EVENTS.RELOAD)
    }
  }
</script>


<style>
  .underlign-hover:hover {
    text-decoration: underline;
  }

  p.description {
    white-space: pre-wrap;
  }

  .iframe-container {
    position: relative;
    padding-top: 70%
  }

  .iframe-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/program/ProgramVue.vue